import React from 'react';
import { useFelaEnhanced } from '@ackee/fela';

import { useCurrentURL } from 'hooks/useCurrentURL';

import { FacebookIcon, TwitterIcon } from '../icons';

import type { BlogPostDetail } from '../../../types';

import * as felaRules from './ShareContainer.rules';

export interface ShareContainerProps {
    title: BlogPostDetail['title'];
}

export const ShareContainer = ({ title }: ShareContainerProps) => {
    const { styles } = useFelaEnhanced(felaRules);

    const currentURL = useCurrentURL();

    return (
        <div className={styles.container}>
            <a
                href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${currentURL}`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
            >
                <TwitterIcon />
            </a>
            <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${currentURL}`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
            >
                <FacebookIcon />
            </a>
        </div>
    );
};
